export class StoreUtil {
    static execute(callback) {
        setTimeout(() => { callback(); }, 0);
    }
}
